import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

import { OpenLRExtendedLinear } from 'app/models/openlr';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { LinearOpenlrComponent } from 'app/shared/openlr/linear/linear-openlr.component';

@Component({
  selector: 'linear-details-openlr',
  templateUrl: './linear-details-openlr.component.html',
  styleUrls: ['./linear-details-openlr.component.scss']
})
export class LinearDetailsOpenlrComponent implements OnInit {
  @Input() id: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() openlr: OpenLRExtendedLinear;
  @ViewChildren(LinearOpenlrComponent) openlrComponents: QueryList<LinearOpenlrComponent>;

  public collapsed: boolean;

  constructor() {}

  ngOnInit(): void {
    this.collapsed = false;
  }

  public collapse() {
    this.collapsed = !this.collapsed;
    this.openlrComponents.forEach(oc => oc.collapse(this.collapsed));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/linear-details/openlr/linear-details-openlr.component.ts